import { useState, useEffect } from "react";
import Breadcrumbs from "./BreadCrumbs";
import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import { DataGridPro, gridRowIdsSelector, useGridApiRef } from "@mui/x-data-grid-pro";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { CmpDatePickerField001V1 } from "../../Component/Common/ToolBox/ToolBoxV1";
import GCAutocompleteCheckboxFixSizeUid from "./GCAutocompleteCheckboxFixSizeUid";
import "./StockSetupChangeRequest.css";
import {  Head_Set } from "./SliceStockSetupChangeRequest";
import { vRdxUserInfo } from "../../Redux/roStore";
import {
  fcheck_null_undefine_replace_empty,
  getStatusStyleV1,
  getUniqueValues,
} from "../../Utility/Utilitys";
import { ISTCRA_Summary } from "../../Server/ApiV2";
import { useNavigate } from "react-router-dom";
import { createMultiSelectOperator } from "../../Component/Common/ReuseableComponent/DatagridFilterColumnComp";

const statusOptions = ["All", "Enter", "Post"];

export default function StockSetupChangeRequest() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const apiRef = useGridApiRef();
const vRdxUserInfoObj = vRdxUserInfo();
  const vRdxHead = useSelector(
    (state) => state.SliceStockSetupChangeRequest.value.Head
  );
  const vRdxuserLoc = useSelector(
    (state) => state.SliceDB.value.Location.LocWithRights
  );
  const isMobile = useMediaQuery("(max-width:650px)");

  const [rows, setRows] = useState([]);
      const [filterObj, setFilterObj] = useState({
      dateFrom: moment().startOf("month").toDate(),
      dateTo: moment().toDate(),
      location: vRdxuserLoc?.map((item) => item.Uid),
      status: "All", 
    });
  const multiSelectMUIlocation = getUniqueValues(rows, "Loc_Name");

    const loadSummary = async () => {
      const locationStr = Array.isArray(filterObj?.location)
        ? filterObj?.location.join(",")
        : filterObj?.location || "";
      const response = await ISTCRA_Summary(
        fcheck_null_undefine_replace_empty({
          FromDate: moment(filterObj?.dateFrom).format("MM/DD/YYYY") || "",
          ToDate: moment(filterObj?.dateTo).format("MM/DD/YYYY") || "",
          Location: locationStr,
          Status: filterObj?.status || "",
          UserCd: vRdxUserInfoObj?.UserID || "",
        })
      );
      if (response?.status === 200) {
        setRows(response?.data?.recordset);
      }
    };

  const handleRowClick = (params) => {
    dispatch(
      Head_Set({
        ...vRdxHead,
        A_Transid: params.row?.A_Transid,
        A_Date: params.row?.A_Date,
        A_Location: params.row?.A_Location,
        Loc_Name: params.row?.Loc_Name,
        A_Narration: params.row?.A_Narration,
        A_Status: params.row?.A_Status,
        CreatedBy: params.row?.CreatedBy,
        CreatedDate: params.row?.CreatedDate,
        ApproveStatus: params.row?.ApproveStatus,
        ApprovedBy: params.row?.ApprovedBy,
        ApproveDt: params.row?.ApproveDt,
        LPOGruppen: params.row?.LPOGruppen,
        LPOGruppenName: params.row?.LPOGruppenName,
        A_Status_CM: params.row?.A_Status_CM,
        A_Status_PM: params.row?.A_Status_PM,
      })
    );
    navigate("/StockSetupChangeRequestDetail");
  };

   const handleExport = () => {
  apiRef.current.exportDataAsCsv({
    getRowsToExport: ({ apiRef }) => gridRowIdsSelector(apiRef),
    includeHeaders: true,
    utf8WithBom: true,
  });
  };
  const handlePrint = () => {
    apiRef.current.exportDataAsPrint();
  };

  return (
    <>
    <div className="div-container">
      <Box sx={{ my: { xs: 0, sm:1  } }}>
        <Breadcrumbs />
      </Box>
      <Grid
        container
        spacing={{ xs: 1.5, md: 1 }}
        sx={{ alignItems: { xs: "flex-end" }, mt: { xs: 1, sm: 0 } }}
      >
        <Grid item xs={6} sm={3} md={2.5} lg={1.5}>
          <Typography>From Date</Typography>
          <CmpDatePickerField001V1
            xLabelText=""
            xName={"dateFrom"}
            xValue={filterObj?.dateFrom}
            xOnChange={(val) =>
              setFilterObj((p) => ({ ...p, dateFrom: val?.$d ?? val }))
            }
          />
        </Grid>
        <Grid item xs={6} sm={3} md={2.5} lg={1.5}>
          <Typography>To Date</Typography>
          <CmpDatePickerField001V1
            xLabelText=""
            xName={"dateTo"}
            xValue={filterObj?.dateTo}
            xOnChange={(val) =>
              setFilterObj((p) => ({ ...p, dateTo: val?.$d ?? val }))
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4.5} lg={4}>
          <Typography>Location</Typography>
          <GCAutocompleteCheckboxFixSizeUid
            options={vRdxuserLoc ?? []}
            xValue={filterObj?.location}
            setValue={(updated) =>
              setFilterObj((p) => ({ ...p, location: updated }))
            }
            objName="location"
            label=""
            placeholder="Search Location"
          />
        </Grid>
        <Grid item xs={12} sm={3} md={2.5} lg={1.5}>
          <Typography>Status</Typography>
          <FormControl fullWidth>
            <Select
              size="small"
              value={filterObj?.status}
              onChange={(e) =>
                setFilterObj((p) => ({ ...p, status: e?.target?.value }))
              }
            >
              {statusOptions?.map((status) => (
                <MenuItem className="menuSm" key={status} value={status}>
                  {status}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid
          item
          xs={12}
          sm={9}
          md={12}
          lg={3.5}
          container
          justifyContent="flex-end"
        >
          <Box display="flex" flexWrap="wrap" gap={1}>
            <Button
              size="small"
              variant="contained"
              sx={{ minWidth: { xs: "auto", sm: 100 } }}
              onClick={loadSummary}
            >
              Load
            </Button>
            <Button
              variant="contained"
              size="small"
              onClick={() => {
                dispatch(
                  Head_Set({
                    A_Transid: 0,
                    A_Date: new Date(),
                    A_Location:
                      vRdxuserLoc?.length > 0 ? vRdxuserLoc[0]?.Uid : "",
                    Loc_Name: "",
                    A_Narration: "",
                    A_Status: "ENTER",
                    CreatedBy: "",
                    CreatedDate: "",
                    ApproveStatus: "ENTER",
                    ApprovedBy: "",
                    ApproveDt: "",
                    LPOGruppen: "",
                    LPOGruppenName: "",
                    A_Status_CM: "",
                    A_Status_PM: "",
                  })
                );
                navigate("/StockSetupChangeRequestDetail");
              }}
              sx={{ minWidth: 100 }}
            >
              New
            </Button>
            <Tooltip title="Export CSV">
              <IconButton color="primary" onClick={handleExport} size="small">
                <DownloadOutlinedIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Print">
              <IconButton color="primary" onClick={handlePrint} size="small">
                <PrintOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Grid>
      </Grid>
      <Box
          mt={1}
        sx={{
          height: {
            xs: "55vh", sm: "68vh", md: "71vh", lg: "74vh",xl:"78vh"
          },
        }}
      >
        <DataGridPro
          rowHeight={30}
          headerHeight={40}
          apiRef={apiRef}
          rows={rows}
          getRowId={(v) => v.A_Transid}
          columns={[
            {
              field: "A_Transid",
              headerName: "Trans No",
              width: 70,
              align: "center",
            },
            {
              field: "A_Date",
              headerName: "Date",
              width: 95,
              align: "center",
              valueFormatter: ({ value }) =>
                moment(value).format("DD/MM/YYYY") == "Invalid date"
                  ? ""
                  : moment(value).format("DD/MM/YYYY"),
            },
            {
              field: "A_Location",
              headerName: "Location ID",
              width: 100,
              hide: true,
            },
            {
              field: "Loc_Name",
              headerName: "Trans Location",
              filterOperators: [
                createMultiSelectOperator(multiSelectMUIlocation),
              ],
              width: 150,
            },
            {
              field: "LPOGruppenName",
              headerName: "LPO Group",
              width: 120,
            },
            {
              field: "A_Narration",
              headerName: "Narration",
                       minWidth: 160,
              hide: isMobile,
            },
            {
              field: "A_Status",
              headerName: "Status",
              width: 75,
              renderCell: (params) => {
                const style = getStatusStyleV1(params.value);
                return (
                  <div
                    style={{
                      ...style,
                      padding: "2px 8px",
                      borderRadius: "4px",
                      textAlign: "center",
                      width: "100%",
                      fontWeight: "bold",
                    }}
                  >
                    {params.value}
                  </div>
                );
              },
            },
            {
              field: "A_Status_CM",
              headerName: "CM Status",
              width: 80,
              renderCell: (params) => {
                const style = getStatusStyleV1(params.value);
                return (
                  <div
                    style={{
                      ...style,
                      padding: "2px 8px",
                      borderRadius: "4px",
                      textAlign: "center",
                      width: "100%",
                      fontWeight: "bold",
                    }}
                  >
                    {params.value}
                  </div>
                );
              },
            },
            {
              field: "A_Status_PM",
              headerName: "PM Status",
              width: 80,
              renderCell: (params) => {
                const style = getStatusStyleV1(params.value);
                return (
                  <div
                    style={{
                      ...style,
                      padding: "2px 8px",
                      borderRadius: "4px",
                      textAlign: "center",
                      width: "100%",
                      fontWeight: "bold",
                    }}
                  >
                    {params.value}
                  </div>
                );
              },
            },
            {
              field: "ApproveStatus",
              headerName: "Appr Status",
              width: 80,
              renderCell: (params) => {
                const style = getStatusStyleV1(params.value);
                return (
                  <div
                    style={{
                      ...style,
                      padding: "2px 8px",
                      borderRadius: "4px",
                      textAlign: "center",
                      width: "100%",
                      fontWeight: "bold",
                    }}
                  >
                    {params.value}
                  </div>
                );
              },
            },
            {
              field: "CreatedBy",
              headerName: "Created By",
              width: 110,
            },
            {
              field: "CreatedDt",
              headerName: "Created Date",
              width: 95,
              align: "center",
              valueFormatter: ({ value }) =>
                moment(value).format("DD/MM/YYYY") == "Invalid date"
                  ? ""
                  : moment(value).format("DD/MM/YYYY"),
            },
            {
              field: "A_CM_By",
              headerName: "Appr By CM",
              width: 110,
            },
            {
              field: "A_CM_Dt",
              headerName: "CM Appr Date",
              width: 100,
              align: "center",
              valueFormatter: ({ value }) =>
                moment(value).format("DD/MM/YYYY") == "Invalid date"
                  ? ""
                  : moment(value).format("DD/MM/YYYY"),
            },
            {
              field: "A_PM_By",
              headerName: "Appr By PM",
              width: 110,
            },
            {
              field: "A_PM_Dt",
              headerName: "PM Appr Date",
              width: 100,
              align: "center",
              valueFormatter: ({ value }) =>
                moment(value).format("DD/MM/YYYY") == "Invalid date"
                  ? ""
                  : moment(value).format("DD/MM/YYYY"),
            },
            {
              field: "ApprovedBy",
              headerName: "Confirm By",
              width: 110,
            },
            {
              field: "ApproveDt",
              headerName: "Confirm Date",
              width: 95,
              align: "center",
              valueFormatter: ({ value }) =>
                moment(value).format("DD/MM/YYYY") == "Invalid date"
                  ? ""
                  : moment(value).format("DD/MM/YYYY"),
            },
          ]}
          hideFooter={true}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0
              ? "mui-even-row"
              : "mui-odd-row"
          }
          sx={{
            border: 1,
            borderColor: "primary.light",
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#0d73bb",
              color: "white",
            },
          }}
          onRowDoubleClick={(params) => {
            handleRowClick(params);
          }}
        />
      </Box>
      </div>
    </>
  );
}
